export default {
  close: 'Cerrar'
}
